
<template>
  <div class="page-header">
    <div class="panel panel-default">
      <div class="panel-heading">拼红包功能简介</div>
      <div class="panel-body">
        <p class="p1">功能简介:</p>
        <p
          class="span1"
        >拼红包功能需要公众号已开通微信支付后才可以对接使用。红包参与者可以创建抢红包队伍，并将红包活动页面转发给好友集结队伍。每位加入的好友随机获得手气分，队伍总分达到商家设置的红包人气分级别要求，队伍成员即可瓜分对应档次的红包金额。红包总金额由商家自主设置，活动结束后由系统随机分配金额给队伍的每一个成员。拼红包功能多用于节日、店庆、特殊日期、购物节等等。在加上商家的红包奖励驱动，粉丝的参与和分享动力瞬间被觉醒。借助节日气氛，商家的活动被大量转发、火爆传播，商家品牌传遍每一个角落，公众号也顺势获得曝光的机会。f</p>
        <p class="p1">适用账号</p>
        <p class="span1">认证服务号并且达到商户平台开通红包的要求</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.panel-heading {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  line-height: 20px;
  span {
    float: right;
  }
}
.panel-body {
  color: #666;
  .span1 {
    font-size: 16px;
    margin: 30px 0;
    color: #666;
    line-height: 32px;
    letter-spacing: 1px;
  }
  .p1 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
    letter-spacing: 1px;
  }
}
</style>


